import staffModel from "./staff-model";
import { defaultPaginationState } from "utils";

export default {
	currentStaff: staffModel,
	isAddModalShowing: false,
	isEditModalShowing: false,
	isNew: false,
	saving: false,
	searchFilter: "",
	// Last unfiltered staff page. Search replaces pagination.results, so
	// supervisor options and name lookups must read this instead.
	directory: [],
	pagination: defaultPaginationState,
	flags: {
		create: "none",
		update: "none",
		delete: "none",
	},
};
